export const formatDisclaimerText = (disclaimer: string | undefined) => disclaimer?.replace(/<[^>]*>/g, '')
